import { render, staticRenderFns } from "./EntryDetail.vue?vue&type=template&id=25e2784d&scoped=true&"
import script from "./EntryDetail.vue?vue&type=script&lang=js&"
export * from "./EntryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e2784d",
  null
  
)

export default component.exports